import { FormControl, FormGroup } from '@angular/forms';
import { Nillable } from '@web/utils';
import { AdminMultimediaImageUpload } from '@web/shared/module/multimedia';

export type AdminPaymentMethodFormControls = {
  description: FormControl<Nillable<string>>;
  isActive: FormControl<Nillable<boolean>>;
  name: FormControl<Nillable<string>>;
  previewFile: FormControl<Nillable<AdminMultimediaImageUpload>>;
};

export class AdminPaymentMethodFormData {
  public static NameMaxLength = 255;
  public static DescriptionMaxLength = 10000;

  public constructor(
    private readonly data: {
      description: string;
      isActive: boolean;
      name: string;
      previewFile: Nillable<AdminMultimediaImageUpload>;
    },
  ) {}

  public get description(): string {
    return this.data.description;
  }

  public get isActive(): boolean {
    return this.data.isActive;
  }

  public get name(): string {
    return this.data.name;
  }

  public get previewFile(): Nillable<AdminMultimediaImageUpload> {
    return this.data.previewFile;
  }
}

/* prettier-ignore */
export type AdminPaymentMethodFormGroup = FormGroup<AdminPaymentMethodFormControls>;
